import { Component } from 'react';
import { Modal, Table } from "react-bootstrap";

import { Col, Row, Container } from "react-bootstrap";
import RomData from '../../data/RomData';

export default class RomAddressOffsetDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    render() {
        return (
            <Modal show={this.props.visible} fullscreen={false} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Rom Address Offsets</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="level-review-dialog">
                        <Container>
                            <Row>
                                <Col>
                                    <p className="mt-3">
                                        This shows the offsets this tool rewrites to update the rom. If you wanna hack things, these are some useful addresses.
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Address</th>
                                                <th>Length</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {RomData.patches.map((patch, idx) => {
                                                const addr = patch.address, len = patch.length;
                                                return (<tr key={`patch-${patch.name}-${patch.symbol}${idx}`}>
                                                    <td>{patch.symbol.length ? patch.symbol.replace('_', '') : patch.name}</td>
                                                    <td>0x{addr.toString('16')}</td>
                                                    <td>{len || 1}</td>
                                                </tr>)
                                            })}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                    </Container>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}